import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-console" }
const _hoisted_2 = { class: "content" }

import ListConsoleSlug from "@/components/lists/list-console-slug.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'slug',
  props: {
    consoleId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ListConsoleSlug, {
        "owner-id": __props.consoleId,
        type: null
      }, null, 8, ["owner-id"])
    ])
  ]))
}
}

})